'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavbarHeader = require('react-bootstrap/lib/NavbarHeader');

var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NavbarHeader2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/NavbarHeader.js
// module id = 649
// module chunks = 0